import React from "react";
import { StyledTitle } from "../../Styled-component/StyledTitle";
import blogGif from "./blogImg/qWalk.gif";
import { BlogData } from "./BlogData";
import { FaArrowRight, FaAngleRight } from "react-icons/fa";
import { BsMedium } from "react-icons/bs";
import "./blog.css";

export const Blog = () => {
  return (
    <div>
      <StyledTitle title="My Blogs" />
      <h2 className="blog-h3">
        In my free time, I like to write blogs in medium. The best way to spread
        your knowledge among others is blog writing. And my blogs are helpful
        for absolute beginners programmers.
      </h2>
      <div className="div-grid-center">
        <section className="blog-outer-section">
          {BlogData.map((blogD) => {
            const { id, title, img, des, links, date, author, dataAos } = blogD;
            return (
              <article key={id} className="blog-article" data-aos={dataAos}>
                <div className="img-blog-box">
                  <img src={img} alt={title} className="blog-img" />
                  <div className="p-date">
                    <p>
                      Published on
                      <br />
                      {date}
                    </p>
                  </div>
                </div>
                <h3>{title}</h3>
                <p className="aut">{author}</p>
                <p className="des">{des && des.slice(0, 100)}......</p>
                <div className="button-container-blog">
                  <a
                    href={links}
                    className="bloglink"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={blogGif} alt="" className="gif-img-qA" />
                    Read More
                    <FaArrowRight />
                  </a>
                </div>
              </article>
            );
          })}
        </section>
      </div>
      <div className="medium-button-container">
        <a
          href="https://medium.com/@shawnniamul58"
          target="_blank"
          rel="noreferrer"
          className="a-github"
        >
          <button className="git-hub-project-button medBtn">
            <BsMedium className="bsmed"/> See more on Medium
            <FaAngleRight />
          </button>
        </a>
      </div>
    </div>
  );
};
